/** Client-side match % (aligned with server skillMatch.js). */

export function normalizeSkillList(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) {
    return raw
      .flatMap(item => {
        const s = String(item || '').trim();
        if (!s) return [];
        if (s.includes(',')) return s.split(',').map(x => x.trim()).filter(Boolean);
        return [s];
      })
      .filter(Boolean);
  }
  if (typeof raw === 'string') {
    return raw
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }
  return [];
}

/** Overall fit % (360° score); falls back to legacy skills-only weighting. */
export function computeMatchPercent({
  matchPercent,
  overallMatchPercent,
  mustMatched = [],
  niceMatched = [],
  totalMust = 0,
  totalNice = 0,
  totalWeight,
  matchedWeight
}) {
  if (typeof overallMatchPercent === 'number' && !Number.isNaN(overallMatchPercent)) {
    return Math.round(overallMatchPercent);
  }
  if (typeof matchPercent === 'number' && !Number.isNaN(matchPercent)) {
    return Math.round(matchPercent);
  }

  const tw = totalWeight ?? totalMust * 2 + totalNice;
  const mw =
    matchedWeight ?? (mustMatched?.length || 0) * 2 + (niceMatched?.length || 0);

  if (tw > 0) {
    return Math.round((mw / tw) * 100);
  }
  if (totalMust > 0) {
    return Math.round(((mustMatched?.length || 0) / totalMust) * 100);
  }
  if (totalNice > 0) {
    return Math.round(((niceMatched?.length || 0) / totalNice) * 100);
  }
  return 0;
}

export function jobSkillCounts(job) {
  const mustCore = normalizeSkillList(job?.mustHaveSkills);
  const niceCore = normalizeSkillList(job?.niceToHaveSkills);
  const mustTech = normalizeSkillList(job?.mustHaveTechnicalSkills);
  const niceTech = normalizeSkillList(job?.niceToHaveTechnicalSkills);
  const must = mustCore.length + mustTech.length;
  const nice = niceCore.length + niceTech.length;
  return {
    must,
    nice,
    total: must + nice,
    mustCore: mustCore.length,
    niceCore: niceCore.length,
    mustTech: mustTech.length,
    niceTech: niceTech.length
  };
}
